<template>
  <div class="archives">
    <div v-if="toolbarEnabled && studio && shows.length > 0" class="options-toolbar" ref="optionsToolbar">
      <div class="selector-container show-container">
        <label for="show-selector">Show</label>
        <select v-model="showSelected" v-on:change="selectShow($event.target.value, {clearDate: true})">
          <option value="">All Shows</option>
          <option id="show-selector" v-for="show in shows" :value="show.id" v-text="show.title"></option>
        </select>
      </div>
      <div class="selector-container date-container">
        <label for="date-selector">Date</label>
        <div class="datepicker-container">
          <datepicker
            :id="'date-selector'"
            :value="dateSelected"
            :format="'MMMM d, yyyy'"
            :inline="false"
            full-month-name
            clear-button
            :highlighted="datesHighlighted"
            :disabled-dates="datesDisabled"
            @selected="selectDate"
            @cleared="selectDate(null)"
            ref="archiveDatePicker"
          ></datepicker>
        </div>
      </div>
    </div>
    <div v-if="toolbarEnabled" :style="{height: optionsToolbarHeight + 'px'}" class="options-toolbar-spacer"></div>
    <div class="archives-list" v-if="studio && broadcasts">
      <transition-group name="fade" tag="ul" mode="out-in">
        <li v-if="broadcast.audio ? broadcast.audio.url : null" v-for="broadcast in broadcasts" v-bind:key="broadcast.id" mode="out-in">
          <div 
            class="audio-player-container" 
            :class="{
              'audio-player-disable-seek': broadcast.show.archives_disable_seek
            }"
            v-if="broadcast.audio && broadcast.audio.url"
          >
            <aplayer
              :music="{
                title: broadcast.show ? broadcast.show.title : studio.title,
                artist: getBroadcastDisplayTitle(broadcast),
                src: broadcast.audio ? broadcast.audio.url : null,
                pic: studio.archives_image_url,
                theme: '#3cf',
              }"
            />
          </div>
        </li>
      </transition-group>
      <!--
        <li v-if="broadcasts.length == 0">
          No archives found.
        </li> 
      -->
    </div>
  </div>
</template>

<script type="text/javascript">

import axios from 'axios'
import { format, parse } from 'fecha'
import VueAPlayer from 'vue-aplayer'
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'Archives',
  props: {
    studio: Object,
    broadcasts: Array,
    shows: Array,
    toolbarEnabled: true,
  },
  components: {
    aplayer: VueAPlayer,
    Datepicker,
  },
  data(){
    return {
      showSelected: '',
      dateSelected: null,
      datesDisabled: {
        // to: new Date(2020, 10, 6),
        // ranges: [{
          // from: new Date(2020, 9, 6)}
        // from: new Date(9999, 1, 1)
      },
      datesHighlighted: {
        from: new Date(0,0,0),
        to: new Date(),
        includeDisabled: true
      },
      optionsToolbarHeight: 100,
      fixSpacerHeightInterval: null,
    }
  },
  methods: {

    selectShow(showId, options = null){
      
      this.showSelected = showId
      this.$emit('show-select', showId)

      // Clear the date.
      if(options && options.clearDate){
        this.selectDate(null)
        this.$refs.archiveDatePicker.clearDate()
      }

    },

    selectDate(date = null){

      if(!date){
        this.$emit('date-select', null)
        return
      }

      this.dateSelected = date
      const dateFormatted = format(date, 'isoDate')
      this.$emit('date-select', dateFormatted)

      // Reset show to All Shows.
      this.selectShow('', { clearDate: false });
      this.showSelected = ''

    },

    getBroadcastDisplayTitle(broadcast){
      
      let title = ''
      let startFormat = 'h:mmA, MMMM Do, YYYY'
      let endFormat = 'h:mmA, MMMM Do, YYYY'

      const startParsed = parse(broadcast.start, 'isoDateTime')
      const endParsed = parse(broadcast.end, 'isoDateTime')

      try{

        if(format(startParsed, 'D') == format(endParsed, 'D')){
          startFormat = 'h:mmA'
        }

        title = format(startParsed, startFormat)
          + ' - '
          + format(endParsed, endFormat)

      }catch(error){
        X(error)
      }

      return title
    },

    fixSpacerHeight () {
      if(this.$refs.optionsToolbar){
        this.optionsToolbarHeight = this.$refs.optionsToolbar.clientHeight
      }
    },

  },
  created(){

    this.fixSpacerHeightInterval = setInterval(
      this.fixSpacerHeight, 500
    )

  },
  // destroy(){
  //   clearInterval(this.fixHeightInterval)
  // }
}

</script>

<style lang="stylus">

.archives
  font-family Arial, Helvetica, sans-serif, sans

ul
  // margin 20px
  margin 0
  // padding 20px
  padding 0

li
  margin 0 0 30px 0
  list-style none

.vdp-datepicker__clear-button
  font-size 24px
  color #fff
  border 2px solid rgba(255,255,255,0.3)
  border-radius 4px
  padding 3px 7px 3px 5px
  margin-left 4px
  display inline
  

.options-toolbar
  margin-bottom 20px
  padding 20px 20px 4px 20px
  // margin -20px -20px 20px -20px
  background #222
  overflow show
  position fixed
  top 0
  left 0
  width 100%
  box-sizing border-box
  display flex
  flex-direction row
  flex-wrap wrap
  z-index 2
  

  div.selector-container
    margin-bottom 20px
  
  .show-container
    // flex-grow 2
    margin-right 30px
    display flex
    // flex-grow 4
    // flex-direction row
    label
      padding 10px 0 10px 0
      font-size 18px
      // flex-grow 1
    select
      // max-width 100%
      max-width 240px
      // margin 0 10px 0 0
      // flex-grow 2
      
  .date-container
    // flex-grow 4
    // flex-grow 2
    display flex
    label
      font-size 18px
      padding 10px 0 10px 0
      flex-grow 1
      // float left
    .datepicker-container
      flex-grow 6
      // float left
      // display flex
      input
        max-width 200px

  label
    color #fff
    margin 0 20px 0 0

  select, input
    font-size 16px
    padding 8px 12px
    border 2px solid #555
    background #111
    border-radius 6px
    color #fff
    
    &:hover
      border-color #777
      background #222

.options-toolbar-spacer
  transition all 0.5s
  padding-bottom 20px

.archives-list
  .fade-enter-active, .fade-leave-active
    transition all .5s
  
  .fade-enter, .fade-leave-to 
    opacity 0

  .fade-enter-active
    transition-delay .5s

  // .fade-enter, .fade-leave-to
  //   margin-bottom -10px

  // .fade-leave, .fade-leave-active
  //   position absolute
    
  // .fade-leave-active
  //   display none
    
.aplayer
  
  .aplayer-pic
    width 100px
    height 100px
    border 3px solid #fff
    background-color transparent !important
    
    .aplayer-button
      background #000
      border 8px solid #000
      
    .aplayer-button.aplayer-play
      margin 0 -22px -22px 0
    // .aplayer-play
      
  .aplayer-body 
    .aplayer-info 
      height 94px !important
      
      // padding-left 20px !important
      .aplayer-music
        // margin-left -8px !important
        // height 50px
        margin-bottom 5px
        padding-top 4px
        .aplayer-author
          display block
          font-size 16px !important
          margin-bottom 12px !important
          line-height 120%
        .aplayer-title
          display block
          font-size 18px !important
          margin-bottom 8px
          line-height 120%
          
  .aplayer-controller
    
    // margin-top 4px !important
    // padding-top 4px !important
    
    .aplayer-time
      color rgba(0,0,0,0)
      font-size 0
      
      .aplayer-ptime
        color rgba(0,0,0,0.7)
        font-size 14px
        
      .aplayer-dtime:before
        content '/ '
        margin-left 4px
      
      .aplayer-dtime
        color rgba(0,0,0,0.7)
        font-size 14px
      
      .aplayer-icon-mode.inactive
        display none
        
      .aplayer-volume-wrap 
        
        .aplayer-volume-bar-wrap::after
          content: "";
          position: absolute;
          bottom: -8px;
          left: 0;
          right: 0;
          height: 80px;
          background none
          // background-color: #fff;
          box-shadow: none;
          // box-shadow: 0 1px 4px rgba(0,0,0,.1);
      
        .aplayer-volume-bar
          height 50px !important
          width 7px
          left 9px
          bottom 8px

        .aplayer-icon
          width 22px
          height 22px
          
    .aplayer-bar-wrap
      
      // padding-top 4px

      .aplayer-bar
        padding-left 0px
        margin-left 0px
        // margin-right 10px
        
        .aplayer-played
          
          .aplayer-thumb
            width 12px
            height 12px
            margin-top -8px
            // margin-right -6px
            // margin-left -14px !important
            border-width 3px

.audio-player-disable-seek 
  .aplayer-bar-wrap
    display none !important
  .aplayer-time
    padding-left 4px !important
  
  .aplayer-volume-bar
    border 4px solid #fff
    box-shadow 0 4px 6px rgba(0,0,0,0.4);
    left 6px !important
         
</style>
